'use client';

interface DetailSupertitleProps {
  text: string | undefined;
}

export const DetailSupertitle: React.FC<DetailSupertitleProps> = ({
  text,
}: DetailSupertitleProps) => {
  if (!text) {
    return null;
  }

  return <p className='text-lg font-normal capitalize'>{text}</p>;
};
